module.exports = __webpack_public_path__ + "img/Icon.3c7eb7dc.png";